<template>
    <div class="user_cjhd" v-loading="loading">
        <div class="top_img">
            <img src="@/assets/img/user_info/user_cjhd/top1.png" alt="">
        </div>
        <div class="cj_box">
            <div class="zhuanpan">
                <div class="round_top">
                        <img src="@/assets/img/user_info/user_cjhd/sj1.png" alt="" class="round_top_img1">

                </div>
                <div class="round_top2">
                    <img src="@/assets/img/user_info/user_cjhd/sj2.png" alt="" class="round_top_img2">
                </div>
                <div class="round" :style="{'transform': `rotate(${45*cj_round_num}deg)`,'transition': cj_round_num?'3s':'0s'}" >
                    
                    <img src="@/assets/img/user_info/user_cjhd/round.png" alt="">
                    <div class="rpund_item">
                        <div class="items" :style="{'transform': `rotate(${45*index+1}deg)`,'transform-origin': 'bottom' }" v-for="(item,index) in hd_list" :key="index">
                            <div class="">礼品{{ index+1 }}</div>
                            <div class="">{{item.pro.title}}</div>
                        </div>
                        <div class="items" :style="{'transform': `rotate(${45*(index+hd_list.length)}deg)`,'transform-origin': 'bottom' }" v-for="(item,index) in (8-hd_list.length)" >
                            <!-- <div class="">下浏</div> -->
                            <div class="">谢谢参与</div>
                        </div>
                    </div>
                    
                    
                </div>
                <div class="cj_btns" @click="handle_cj">
                    开始抽奖
                </div>
            </div>

            <div class="jp_num">您的抽奖次数：10次</div>
            <div class="jp_list">
                <div class="list_title">幸运大转盘</div>
                <div class="list_item">
                    <div class="items" v-for="(item,index) in hd_list" :key="index">
                        奖品{{ index+1 }}:{{ item.pro.title }}
                    </div>
                </div>
            </div>
        </div>
        <div class="cj_text">
            <div class="text_title">抽奖规则</div>
            <div class="text_const">
                1、抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则抽奖规则
            </div>
        </div>
        <div class="zj_list">
            <div class="zj_title">我的中奖记录</div>
            <div class="zj_tab">
                <div class="tab_title">
                    <div class="title1">抽中奖项</div>
                    <div class="title2">中将时间</div>
                    <div class="title3">操作</div>
                </div>

                <div class="tab_list">
                    <div class="tab_items" v-for="(item,index) in zj_list" :key="index">
                        <div class="item1">{{ item.product.title }}</div>
                        <div class="item2">{{ item.created_at }}</div>
                        <div class="item3">
                            <span>去使用</span>
                        </div>
                    </div>
                </div>
                <div class="bom_btns" v-if="total>10&&total!=limit">
                    <div class="btns" @click="handle_zk">
                        全部展开
                        <img src="@/assets/img/user_info/user_cjhd/zk.png" alt="">

                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import { mapState} from 'vuex'
 


export default {
    components: {
        
    },
    name: "homes",
    data() {
        return {
            loading: false,
            cj_round_num:0,//旋转的次数
            cj_round_num_ac:0,//已经点击的次数
            hd_detial:{},
            hd_list:[],
            timer:null,
            code_show:true,
            code_time:3,
            zj_list:[],
            limit:'',
            total:0,
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_detial()
        this.get_zj_list()
    },
    methods: {
        handle_zk(){
            this.limit=this.total
            this.get_zj_list()

        },
        get_zj_list(){
            this.loading=true
            this.$api("rewardList", {
                limit:this.limit,
			}, "get").then((res) => {
                this.loading = false
                console.log('中将记录',res)
                if (res.code == 1) {
                    this.zj_list=res.data.data
                    this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_detial(){
            
            this.loading=true
            this.$api("proList", {
                 
			}, "get").then((res) => {
                this.loading = false
                console.log('大转盘',res)
                if (res.code == 1) {
                  this.hd_detial=res.data
                  this.hd_list=res.data.pros
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_cj(){
            if(this.code_show){
                this.loading=true
                this.$api("reward", {
                    reward_id:this.hd_detial.id
                }, "post").then((res) => {
                    this.loading = false
                    console.log('大转盘',res)
                    if (res.code == 1) {
                        this.cj_round_num=0
                        this.cj_round_num_ac++
                        this.hd_list.forEach((e,i)=>{
                            if(e.pro_id==res.data.id){
                                this.cj_round_num=(24*this.cj_round_num_ac)-i
                            }
                        })
                        this.code_show=false
                        this.timer=setInterval(() => {
                            console.log(this.code_time)
                            if(this.code_time==0){
                                this.code_time=3
                                this.code_show=true
                                this.get_zj_list()
                                clearInterval(this.timer)

                            }else{
                                this.code_show=false

                                this.code_time=this.code_time-1
                            }
                        }, 1000);

                    } else {
                        alertErr(res.msg)
                    }
                });
            }
            
           
            

        },



    },

}
</script>
<style scoped lang="less">
.user_cjhd {  
    padding-bottom: 100px;
     .top_img{

     }
     .cj_box{
        width: 1440px;
        height: 865px;
        background: #FEF7F3;
        border-radius: 32px 32px 32px 32px;
        margin: auto;
        margin-top: 40px;
        padding: 60px ;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        position: relative;
        .zhuanpan{
            width: 700px;
            // height: 700px;
            // background-color: red;
            position: absolute;
            left: 50px;
            // top: 100px;
            z-index: 2;
            .round_top{
                position: absolute;
                width: 140px;
                height: 120px;
                top: 20px;
                left: 50%;    //起始是在body中，横向距左50%的位置
                transform:translate(-50%,-50%);//水
                z-index: 3;
                // text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                .round_top_img1{
                    position: absolute;
                    z-index: 2;
                    width: 120px;
                    height: 120px;
                    
                    // top: 0;
                    // left: 50%;    //起始是在body中，横向距左50%的位置
                    // transform:translate(-50%,-0%);//水
                }
                
            }
            .round_top2{
                position: absolute;
                width: 140px;
                height: 120px;
                top: 20px;
                left: 50%;    //起始是在body中，横向距左50%的位置
                transform:translate(-50%,-50%);//水
                z-index: 1;
                // text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
              
                
                .round_top_img2{
                    position: absolute;
                    z-index: 1;
                    width: 140px;
                    // height: 113px;
                    margin-top: 20px;
                }
            }
            .round{
                width: 700px;
                height: 700px;
                position: relative;
                z-index: 2;
                
               

                img{
                    position: absolute;
                    left: 0;
                    top: 0;
                    transform: rotate(22.5deg);

                }
                .rpund_item{
                    position: relative;
                    z-index: 2;
                    height: 700px;
                    // transform: rotate(20deg);
                    .items{
                        width: 150px;
                        height: 250px;
                        // background: red;
                        position: absolute;
                        bottom: 350px;
                        // left: 350px;
                        left: 275px;
                        text-align: center;
                        font-weight: normal;
                        font-size: 17px;
                        color: #400000;
                   
                        // border-left: 10px solid transparent;
                        // border-right: 10px solid transparent;
                        // border-bottom: 10px solid  #5C77FF;

                    }
                }
                
            }
            .cj_btns{
                position: absolute;
                width: 50px;
                // height: 100px;
                // background-color: red;
                z-index: 2;
                left: 50%;    //起始是在body中，横向距左50%的位置
                top:50%;      //起始是在body中，纵向距上50%的位置，这个点相当于body的中心点，div的左上角的定位
                transform:translate(-50%,-50%);//水平、垂直都居中,也可以写成下面的方式
                font-weight: bold;
                font-size: 24px;
                color: #A61B1E;
                cursor: pointer;
            }
        }
        .jp_num{
            width: 500px;
            height: 100px;
            background: #FFFFFF;
            box-shadow: inset 0px 0px 24px 1px #F2464A;
            border-radius: 32px 32px 32px 32px;
            border: 10px solid #F2474B;
            font-weight: bold;
            font-size: 24px;
            color: #666666;
            // line-height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;

        }
        .jp_list{
            width: 972px;
            height: 622px;
            background: #FFFFFF;
            // box-shadow: inset 0px 0px 24px 1px #9B0004;
            border-radius: 40px 40px 40px 40px;
            border: 10px solid #F2474B;
            position: relative;
            z-index: 1;
         
            .list_title{
                width: 636px;
                height: 99px;
                background: linear-gradient( 90deg, #FFFFFF 0%, #F2474B 48%, #FFFFFF 100%);
                border-radius: 0px 0px 0px 0px;
                position: absolute;
                right: 20px;
                top: 79px;
                font-size: 40px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .list_item{
                width: 636px;
                position: absolute;
                right: 20px;
                top: 212px;
                .items{
                    font-weight: 400;
                    font-size: 20px;
                    color: #9F6038;
                    text-align: center;
                    line-height: 45px;
                }
            }
        }
     }
     .cj_text{
        width: 1440px;
        margin: auto;
        padding-top: 80px;
        .text_title{
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 32px;
            color: #9F6038;
        }
        .text_const{
            width: 1100px;
            padding-top: 40px;
            margin: auto;
        }
     }
     .zj_list{
        width: 1440px;
        margin: auto;
        padding-top: 100px;
        .zj_title{
            width: 500px;
            height: 100px;
            background: #FFFFFF;
            box-shadow: inset 0px 0px 24px 1px #F2464A;
            border-radius: 32px 32px 32px 32px;
            border: 6px solid #F2474B;
            margin: auto;
            font-weight: bold;
            font-size: 32px;
            color: #9F6038;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .zj_tab{
            width: 1440px;
            // min-height: 738px;
            border-radius: 32px 32px 32px 32px;
            border: 2px solid #F6E3D8;
            margin-top: 33px;
            overflow: hidden;
            .tab_title{
                width: 100%;
                height: 80px;
                background: #FEDAB3;
                border-radius: 32px 32px 0px 0px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .title1{
                    width: 300px;
                    text-align: center;
                    font-weight: bold;
                    font-size: 20px;
                    color: #9F6038;

                }
                .title2{
                    width: 200px;
                    font-weight: bold;
                    font-size: 20px;
                    color: #9F6038;
                }
                .title3{
                    width: 300px;
                    text-align: center;
                    font-weight: bold;
                    font-size: 20px;
                    color: #9F6038;
                }
            }
            .tab_list{
                .tab_items{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 70px;
                    border-bottom: 2px solid #FEDAB3;
                    background-color: #F6E3D8;
                    
                    .item1{
                        width: 300px;
                        text-align: center;

                    }
                    .item2{
                        width: 200px;
                    }
                    .item3{
                        width: 300px;
                        text-align: center;
                        span{
                            cursor: pointer;
                            font-weight: 400;
                            font-size: 20px;
                            color: #377CFD;

                        }
                    }
                }
            }
            .bom_btns{
                width: 1440px;
                height: 80px;
                background: #FFFFFF;
                box-shadow: 0px 3px 16px 1px rgba(254,220,185,0.6);
                border-radius: 0px 0px 32px 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                .btns{
                    font-weight: 400;
                    font-size: 18px;
                    color: #9F6038;
                    cursor: pointer;
                    img{
                        width: 15px;
                        height: 12px;
                    }
                }
            }
        }
     }
}
</style>